import axios from '@/axios' // nuestro archivo de configuración axios

export default {
  namespaced: true,
  state: {
    items: [],
    loading: false
  },
  getters: {
    all: state => state.items
  },
  mutations: {
    SET_ITEMS(state, payload) {
      state.items = payload
    },
    SET_LOADING(state, payload) {
      state.loading = payload
    }
  },
  actions: {
    async fetchAll({ commit }) {
      commit('SET_LOADING', true)
      try {
        const { data } = await axios.get('/articulos')
        commit('SET_ITEMS', data)
      } catch (err) {
        console.error('Error fetching articles:', err)
        commit('SET_ITEMS', []) // en error dejamos vacío
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async create({ dispatch }, payload) {
      try {
        await axios.post('/articulos', payload)
        dispatch('fetchAll')
      } catch (err) {
        throw err
      }
    },
    async update({ dispatch }, { id, payload }) {
      try {
        await axios.put(`/articulos/${id}`, payload)
        dispatch('fetchAll')
      } catch (err) {
        throw err
      }
    },
    async delete({ dispatch }, id) {
      try {
        await axios.delete(`/articulos/${id}`)
        dispatch('fetchAll')
      } catch (err) {
        throw err
      }
    }
  }
}
